import { createAction } from 'redux-actions';
import AuthType from '../types/AuthType';
import AuthenticationService from '../../services/AuthenticationService';
import { failedRequest, startRequest } from './GlobalActions';

const success = (dispatch, actionSuccess) => (userData) => {
  dispatch(actionSuccess(userData));
  return userData;
};

const error = (dispatch) => (error) => {
  dispatch(failedRequest(error, true));
  return { error: true };
};

const userAuthAuthz = ({ roles, capabilities = [], idMerchant = null, ...userData }) => ({
  userData,
  isAuthenticated: !userData.mfaEnabled,
  idMerchant,
  authorization: { roles, capabilities },
});

const loginSuccess = createAction(AuthType.actions.loginSuccess, userAuthAuthz);
export const login =
  ({ username, password }) =>
  (dispatch) => {
    dispatch(startRequest(AuthType.actions.login));
    return AuthenticationService.login(username, password).then(success(dispatch, loginSuccess), error(dispatch));
  };

const switchContextSuccess = createAction(AuthType.actions.switchContextSuccess, userAuthAuthz);
export const switchContext =
  ({ idMerchant, password }) =>
  (dispatch) => {
    dispatch(startRequest(AuthType.actions.switchContext));
    return AuthenticationService.switchContext(idMerchant, password).then(success(dispatch, switchContextSuccess), error(dispatch));
  };

const signInSuccess = createAction(AuthType.actions.signInSuccess);
export const signIn =
  ({ password, confirmPassword }) =>
  (dispatch) => {
    dispatch(startRequest(AuthType.actions.signIn));
    return AuthenticationService.signIn(password, confirmPassword).then(success(dispatch, signInSuccess), error(dispatch));
  };

const authMfaSuccess = createAction(AuthType.actions.authMfaSuccess, userAuthAuthz);
export const authMfa = (data) => (dispatch) => {
  dispatch(startRequest(AuthType.actions.authMfa));
  return AuthenticationService.authenticateMFA(data).then(success(dispatch, authMfaSuccess), error(dispatch));
};

const activateMfaSuccess = createAction(AuthType.actions.activateMfaSuccess);
export const activateMfa =
  ({ mfaCode }) =>
  (dispatch) => {
    dispatch(startRequest(AuthType.actions.activateMfa));
    return AuthenticationService.activateMFA(mfaCode).then(success(dispatch, activateMfaSuccess), error(dispatch));
  };

export const logoutSuccess = createAction(AuthType.actions.logoutSuccess);
export const logout = () => (dispatch) => {
  dispatch(startRequest(AuthType.actions.logout));
  return AuthenticationService.logout().then(() => dispatch(logoutSuccess()), dispatch(logoutSuccess()));
};

export const forgotSuccess = createAction(AuthType.actions.forgotPassSuccess);
export const forgot =
  ({ username }) =>
  (dispatch) => {
    dispatch(startRequest(AuthType.actions.forgotPass));
    return AuthenticationService.forgotPass(username).then(() => dispatch(forgotSuccess()), error(dispatch));
  };

const resetPassSuccess = createAction(AuthType.actions.resetPassSuccess);
export const resetPass =
  ({ password, confirmPassword }) =>
  (dispatch) => {
    dispatch(startRequest(AuthType.actions.authMfa));
    return AuthenticationService.resetPass(password, confirmPassword).then(success(dispatch, resetPassSuccess), error(dispatch));
  };

const resetMfaSuccess = createAction(AuthType.actions.resetMFASuccess, userAuthAuthz);
export const resetMfa =
  ({ mfaCode }) =>
  (dispatch) => {
    dispatch(startRequest(AuthType.actions.resetMFA));
    return AuthenticationService.resetMFA(mfaCode).then(success(dispatch, resetMfaSuccess), error(dispatch));
  };

export const updateLocalUserData = createAction(AuthType.actions.updateLocalUserData, (userData) => userData);
